import { CartFlowController } from "../../CartFlowController";
import { ICartItems } from "../../../../Interfaces/Cart";
import { ProductFlow } from "../ProductFlow";

export class Register extends ProductFlow {
    constructor(cartItems: ICartItems) {
        super("configure-registration", CartFlowController.EVENTS.CONFIGURE_GUARANTEE, cartItems);
    }

    /**
     * obtain tabs from template
     * @private
     */
    protected initTabs(): this {
        super.initTabs();
        this.tabs.dataset.active = "registration";
        return this;
    }
}
